import * as React from 'react';
import { HeaderCellInfoWrapper } from '../../HeaderCellInfoWrapper';
import styles from '@patternfly/react-styles/css/components/Table/table';
export var info = function info(_ref) {
  var tooltip = _ref.tooltip,
      tooltipProps = _ref.tooltipProps,
      popover = _ref.popover,
      popoverProps = _ref.popoverProps,
      className = _ref.className,
      ariaLabel = _ref.ariaLabel;

  var infoObj = function infoObj(value) {
    return {
      className: styles.modifiers.help,
      children: tooltip ? React.createElement(HeaderCellInfoWrapper, {
        variant: "tooltip",
        info: tooltip,
        tooltipProps: tooltipProps,
        ariaLabel: ariaLabel,
        className: className
      }, value) : React.createElement(HeaderCellInfoWrapper, {
        variant: "popover",
        info: popover,
        popoverProps: popoverProps,
        ariaLabel: ariaLabel,
        className: className
      }, value)
    };
  };

  return infoObj;
};